import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <iframe src="https://giphy.com/embed/HRF05wHuIBGAkS1wRt" width="480" height="270" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
      </header>
    </div>
  );
}

export default App;
